import { CMS_API_URL } from 'constants/apiConf';

export const getCMSDocumentSrc = (document) => {
  return `${CMS_API_URL}/cms/documents/public/${document.hash}`;
};
